import React from 'react';

const Header = () => (
	<div id="headerwrap">
	    <div className="container header-intro-mobile">
			<div className="row align-middle">
				<div className="col-lg-6 col-lg-offset-3">
					<h4 className="GreyHeading">Greetings and salutations, my name is</h4>
					<h1>Mirza Šišić</h1>
					<h4 className="GreyHeading">Tester | Blogger | Memer</h4>
					<p className="GreyHeading"><em>Living and working in the city of Sarajevo</em></p>
				</div>
			</div>
	    </div> 
	</div>
);

export default Header;